import PageTitle from 'Molecules/PageTitle/PageTitle';
import UnsavedChangesPrompt from 'Organisms/UnsavedChangesPrompt/UnsavedChangesPrompt';
import TaskBundleFooter from './TaskBundleFooter';
import TaskBundleTabs from './TaskBundleTabs';

import { PATHS } from 'utils/constants';
import { useTaskBundleDraft } from '../../providers/TaskBundleProvider/TaskBundleProvider';
import { TaskBundleMode } from '../../types';
import { getPageTitle } from '../../helpers';

interface TaskBundlePageContentProps {
  activeTab: number;
  onTabChange: (index: number) => void;
  mode: TaskBundleMode;
}

// Separated from TaskBundlePage to safely use useTaskBundleDraft() within the provider boundary.
// TaskBundlePage handles loading state and provider initialization; TaskBundlePageContent handles layout.
const TaskBundlePageContent: React.FC<TaskBundlePageContentProps> = ({
  activeTab,
  onTabChange,
  mode,
}) => {
  const { selectors } = useTaskBundleDraft();

  return (
    <div className='h-full flex flex-col shadow-skim'>
      <UnsavedChangesPrompt
        hasChanges={selectors.isDirty}
        allowedPaths={[
          PATHS.NEW_TASK_BUNDLE_PAGE,
          PATHS.EDIT_TASK_BUNDLE_PAGE,
          PATHS.CLONE_TASK_BUNDLE_PAGE,
        ]}
      />
      <PageTitle
        titleComponent={getPageTitle(mode, selectors.draft.bundle.name)}
      />
      <TaskBundleTabs
        activeTab={activeTab}
        onTabChange={onTabChange}
        mode={mode}
      />
      <TaskBundleFooter mode={mode} />
    </div>
  );
};

export default TaskBundlePageContent;
